<template>
  <div id="user-manage-detail">
    <div class="user-manage-detail flex mar-b-10">
      <div class="user-manage-detail__avatar__img">
        <div class="upload-content">
          <div class="upload-content-img ipub-p2 relative">
            <!-- <img :src="`${domain}/${user.icon||'imageFile/icon.svg'}`"
                 alt=""> -->
            <ipub-upload-cropper @change="handleUpload"
                                 :canWidth="canWidth"
                                 :canHeight="canHeight"
                                 :scales="2"
                                 :imgUrl="user.icon?domain+'/'+user.icon:domain+'/imageFile/icon.svg'" />
          </div>
        </div>
      </div>
      <div class="user-manage-detail__avatar mar-b-20 mar-l-20 ipub-p2">
        <div class="ipub-h2 mar-b-12">
          {{title[user.titleCode]}} {{user.firstName}} {{user.lastName}}
        </div>
        <div class="ipub-p2 role-arr mar-b-8">
          <div class="flex">
            <div class="ipub-p2 fw-bd"
                 style="width:60px">Roles</div>
            <div style="max-width:700px;flex-wrap:wrap"
                 class="flex">
              <div v-for="item in roleArr"
                   :key="item.id"
                   class="nowrap"
                   style="margin-right:10px">
                {{item.name}}
                <template v-if="item.journals&&item.journals.length"> (
                  <template v-for="(val, num) in item.journals">
                    {{val}}
                    <template v-if="num !== item.journals.length-1"> / </template></template>
                  )</template>
              </div>
            </div>
          </div>
        </div>
        <template v-if="type==='manage-employees'">
          <div class="flex">
            <div style="width:60px"
                 class="mar-b-20 ipub-p2 fw-bd">Email</div>
            <div class="ipub-p2">
              {{user.email}}
            </div>
          </div>
        </template>
        <a class="link-color"
           target="_blank"
           v-if="user.icon"
           @click="download(`${domain}/${user.icon}`, `${user.iconName}`)">Download Avatar</a>
      </div>
    </div>
    <div>
      <site-tab class="mar-b-30"
                :menus="menus[this.type]" />
      <router-view :data="user"
                   :roleArr="roleArr"
                   :roleType="roleType"></router-view>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
